import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/accordion'
import * as Input from '@/components/input'
import { Textarea } from '@/components/textarea'
import { GetAgentIndicationDataByIndicationIdResponse } from '@/models/agent'

interface IndicationDetailsProps {
  agentIndicationData: GetAgentIndicationDataByIndicationIdResponse | null
}

export function IndicationDetails({
  agentIndicationData,
}: IndicationDetailsProps) {
  return (
    <Accordion type="single" collapsible>
      <AccordionItem
        value="indication-details-accordion"
        variant="withBackgroundWhite"
      >
        <AccordionTrigger
          className="px-6"
          variant="green"
          isWithIconPlusAndMinus
        >
          Detalhes da indicação
        </AccordionTrigger>
        <AccordionContent className="grid size-full flex-col content-center gap-6 px-6 text-start text-base md:grid-cols-2 xl:grid-cols-4">
          <div className="xl:col-span-1">
            <Input.Label htmlFor="indication_type">
              Tipo de indicações
            </Input.Label>

            <Input.Root>
              <Input.Control
                readOnly
                disabled
                type="text"
                id="indication_type"
                placeholder="Tipo da indicação"
                defaultValue={agentIndicationData?.indicationType.description}
              />
            </Input.Root>
          </div>
          <div className="sm:col-span-1 xl:col-span-2">
            <Input.Label htmlFor="indication_entity">Entidade</Input.Label>

            <Input.Root>
              <Input.Control
                readOnly
                disabled
                type="text"
                id="indication_entity"
                placeholder="Nome da entidade"
                defaultValue={agentIndicationData?.resourceName}
              />
            </Input.Root>
          </div>
          <div className="col-span-1 sm:col-span-2 xl:col-span-1">
            <Input.Label htmlFor="commission">Comissão padrão (%)</Input.Label>

            <Input.Root>
              <Input.Control
                readOnly
                disabled
                type="text"
                id="commission"
                placeholder="Valor da comissão"
                defaultValue={agentIndicationData?.commission}
              />
            </Input.Root>
          </div>

          <div className="sm:col-span-2 xl:col-span-4">
            <Input.Label htmlFor="commission_reason">
              Motivo da porcentagem da comissão
            </Input.Label>
            <Textarea
              isResize
              readOnly
              disabled
              id="commission_reason"
              placeholder="Motivo da porcentagem da comissão"
              defaultValue={agentIndicationData?.commissionReason ?? ''}
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
